import * as types from "~/store/totalData/types";

export const removeSchedule = indexSchedule => {
  return {
    type: types.REMOVE_SCHEDULE,
    indexSchedule
  };
};

export const reviewBooking = () => {
  return {
    type: types.REVIEW_BOOKING
  };
};

export const getExtraConfig = () => {
  return {
    type: types.GET_EXTRA_CONFIG
  };
};

// Set Partner ID
export const setPartnerId = id => {
  return {
    type: types.SET_PARTNER_ID,
    payload: id
  };
};

// Choose hospital
export const selectHospital = (id, hospital = {}) => {
  return {
    type: types.SELECT_HOSPITAL,
    payload: id,
    hospital
  };
};

// reset BookingTree
export const resetBookingTree = () => {
  return {
    type: types.RESET_BOOKING_TREE
  };
};

// getBookingTree
export const getBookingTree = (text = null, id, isAddNew = false) => {
  return {
    type: types.GET_BOOKING_TREE,
    text,
    id,
    isAddNew
  };
};

// SUBJECT
export const selectSubject = subject => {
  return {
    type: types.SELECT_SUBJECT,
    payload: subject
  };
};

export const resetSelectSubject = () => {
  return {
    type: types.RESET_SELECT_SUBJECT
  };
};

export const searchSubject = term => {
  return {
    type: types.SEARCH_SUBJECT,
    payload: term
  };
};

// SUBJECT
export const selectDoctor = doctor => {
  return {
    type: types.SELECT_DOCTOR,
    payload: doctor
  };
};

export const resetSelectDoctor = () => {
  return {
    type: types.RESET_SELECT_DOCTOR
  };
};

export const searchDoctor = term => {
  return {
    type: types.SEARCH_DOCTOR,
    payload: term
  };
};

// SERVICE
export const selectService = id => {
  return {
    type: types.SELECT_SERVICE,
    payload: id
  };
};
export const resetSelectService = () => {
  return {
    type: types.RESET_SELECT_SERVICE
  };
};
export const changeServiceType = serviceType => {
  return {
    type: types.CHANGE_SERVICE_TYPE,
    payload: serviceType
  };
};

// ROOM
export const selectRoom = id => {
  return {
    type: types.SELECT_ROOM,
    payload: id
  };
};
export const resetSelectRoom = () => {
  return {
    type: types.RESET_SELECT_ROOM
  };
};

// DATE
export const selectDate = date => {
  return {
    type: types.SELECT_DATE,
    payload: date
  };
};
export const resetSelectDate = () => {
  return {
    type: types.RESET_SELECT_DATE
  };
};

// TIME SLOT
export const selectTimeSlot = slot => {
  return {
    type: types.SELECT_TIME_SLOT,
    payload: slot
  };
};
export const resetSelectTimeSlot = () => {
  return {
    type: types.RESET_SELECT_TIME_SLOT
  };
};

// RESET ALL DATA
export const resetData = () => {
  return {
    type: types.RESET_DATA
  };
};

// reserveMultipleBookings

export const reserveMultipleBookings = () => {
  return {
    type: types.RESERVE_MULTIPLE_BOOKINGS
  };
};

export const resetPaymentInformation = () => {
  return {
    type: types.RESET_RESETPAYMENTINFORMATION
  };
};

// BOOKING
export const reserveBooking = () => {
  return {
    type: types.RESERVE_BOOKING
  };
};

export const onLoading = () => {
  return {
    type: types.ON_LOADING
  };
};

export const offLoading = () => {
  return {
    type: types.OFF_LOADING
  };
};

export const getPaymentInfo = (id, text = "", typePayment = 1) => {
  return {
    type: types.GET_PAYMENT_INFO,
    payload: id,
    text,
    typePayment
  };
};

export const getBookingInfo = (id, text) => {
  return {
    type: types.GET_BOOKING_INFO,
    payload: id,
    text
  };
};

export const checkRepayment = status => {
  return {
    type: types.CHECK_REPAYMENT,
    payload: status
  };
};

// ADD slotId
export const addSlotId = slotId => {
  return {
    type: types.ADD_SLOTID,
    slotId
  };
};

// ADD SCHEDULE
export const addSchedule = () => {
  return {
    type: types.ADD_SCHEDULE
  };
};

export const addScheduleRepayment = info => {
  return {
    type: types.ADD_SCHEDULE_REPAYMENT,
    payload: info
  };
};

export const resetSchedule = () => {
  return {
    type: types.RESET_SCHEDULE
  };
};

// Check Flow Forward or Back
export const changeDirection = status => {
  return {
    type: types.CHANGE_DIRECTION,
    layload: status
  };
};

// Medical Bills
export const getAllMedicalBills = () => {
  return {
    type: types.GET_ALL_MEDICAL_BILLS
  };
};
export const getAllHiddenMedicalBills = () => {
  return {
    type: types.GET_ALL_HIDDEN_MEDICAL_BILLS
  };
};

export const selectMedicalBill = (id, hospital = {}) => {
  return {
    type: types.SELECT_MEDICAL_BILL,
    payload: id,
    hospital
  };
};
// Booking share to pay
export const bookingShareToPay = id => {
  return {
    type: types.BOOKING_SHARE_TO_PAGE,
    id
  };
};

// Repayment
export const repaymentBooking = (typeRepay, params) => {
  return {
    type: types.REPAYMENT_BOOKING,
    typeRepay,
    params
  };
};
export const changeBookingFlow = flow => {
  return {
    type: types.CHANGE_BOOKING_FLOW,
    flow
  };
};

// reset List node
export const resetListNode = node => {
  return {
    type: types.RESET_LIST_NODE,
    payload: node
  };
};

// reserve payment partner
export const reserveBookingPartner = () => {
  return {
    type: types.RESERVE_PAYMENT_PARTNER
  };
};

// go back step
export const goBackStep = node => {
  return {
    type: types.GO_BACK_STEP,
    node
  };
};

export const setInsuranceChoice = id => {
  return {
    type: types.SET_INSURANCE_CHOICE,
    payload: id
  };
};

export const setScheduleWithoutDate = status => {
  return {
    type: types.SET_SCHEDULE_WITHOUT_DATE,
    payload: status
  };
};

export const requestHospitalInfo = ({ partnerId }) => {
  return {
    type: types.HOSPITAL_INFO,
    payload: { partnerId }
  };
};

export const requestHospitalDescription = ({ slug }) => {
  return {
    type: types.HOSPITAL_DESCRIPTION,
    payload: { slug }
  };
};
